import React, {useState} from "react";
import {
    Drawer,
    ListItem,
    ListItemButton,
    Typography, Divider, Box, IconButton
} from "@mui/material";
import {useTranslation} from 'react-i18next';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MenuBarPopup from "./menu-bar-popup";
import {MenuBarComp} from "../components/menu-bar-comp";
import {MenuOpen} from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";
import {APP_BAR_HEIGHT, belowAppBar, sidebarWidth} from "../components/common/app-layout";

const SidebarMenu = ({tenantType, navOpen, toggleNav,}) => {
    const {t} = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    return (
        <Drawer variant="permanent" anchor="left" sx={{
            "& .MuiDrawer-paper": {
                display: "flex", top: APP_BAR_HEIGHT, height: belowAppBar,
                width: sidebarWidth(navOpen), boxSizing: "border-box", overflowX: "hidden",
            },
        }}>
            <Box sx={{width: "100%", boxSizing: "border-box", p: navOpen ? 2 : 1}}>
                {navOpen ? (
                    <Box>
                        <Typography
                            variant="h6"
                            sx={{
                                mb: 2,
                                fontWeight: "bold",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                            }}
                        >
                            {t("Overview")}
                            <IconButton onClick={toggleNav} aria-label={t("WorkspaceCollapseSidebar")} size="small"><MenuOpen/></IconButton>
                        </Typography>
                    </Box>
                ): <IconButton onClick={toggleNav} aria-label={t("WorkspaceExpandSidebar")}><MenuIcon/></IconButton>}
                <Divider sx={{marginTop: 2, width: "100%"}}/>
                {navOpen ? <MenuBarComp tenantType={tenantType}/> : <ListItem disablePadding>
                    <ListItemButton onClick={handleClick} sx={{display: "flex", justifyContent: "center", marginTop: 2, marginLeft: "-4px"}}>
                        <MoreVertIcon/>
                    </ListItemButton>
                </ListItem>}
                <MenuBarPopup anchorEl={anchorEl} onClose={handlePopoverClose} tenantType={tenantType}/>
            </Box>
        </Drawer>
    );
};

export default SidebarMenu;
